/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, August 23rd 2022, 10:34:40 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { resolveURLName } from "core/routes/utils";
import { FormConfiguration } from "lib/schemas";
import { useServiceBuilderContext } from "service-builder/providers";

export const useNavigateToServiceFormBuilder = () => {
  const navigate = useNavigate();

  const {
    processDefinitionContext: { currentProcessDefinition },
  } = useServiceBuilderContext();

  const navigateToFormBuilder = React.useCallback(
    (formId: FormConfiguration["id"]) => {
      if (currentProcessDefinition?.id) {
        navigate(resolveURLName("serviceFormBuilder", { serviceId: currentProcessDefinition.id, formId }));
      }
    },
    [navigate, currentProcessDefinition?.id]
  );

  return { navigateToFormBuilder };
};
